import * as types from './mutations-types'
import api from '~/api'
import {getSignature, getUserInfo} from '~/assets/js/util'
import {Message} from 'element-ui'
import * as cvsV3 from "@/api/list/cvsV3";


export const getTemplates = async function ({commit}) {
  let {data} = await api.cvs.getCvTemplate()
  commit('SET_TEMPLATES', data)
  return data
}

export const getCvs = async function ({commit}) {
  try {
    let res = await api.cvs.cvIndex(this.$axios, {})
    if (res.status === 1) {
      commit(types.GET_CVS, res.data.cvs)
      commit('SET_TEMPS', res.data.temps)
      commit('SET_CVS_DATA', res.data);
    }
    else {
      setTimeout(() => {
        Message.error('网络出错, 请刷新');
      }, 300);
    }
  } catch (error) {
    commit(types.GET_CVS, [])
    commit('SET_TEMPS', [])
    commit('SET_CVS_DATA', {cvs: []});
    setTimeout(() => {
      Message.error('网络出错, 请刷新');
    }, 300);
  }
}

export const getCv = async function ({commit}, token) {
  try {
    let params = {token};
    // commit(types.GET_CV, {})
    let res = await api.cvs.cvShow(this.$axios, params)
    if (res.status === 1) {
      commit(types.GET_CV, res.data)
      commit('SET_IS_AUTO_ONE_PAGE', false)
      let dealSortAry = res.data.base.sections_position.replace(/{|}|"/g, '').split(',')
      let sortAry = dealSortAry.map(item => {
        return item.split(':')[0]
      })
      commit(types.GET_SORT_ARY, sortAry)
    }
    return res
  } catch (error) {
    console.log(error)
  }
}

// export const getCheck = async ({commit}, token) => {
//   let params = {'cv_token': token}
//   let res = await api.cvs.check(params);
//   commit('SET_CHECK', res.data || {});
// }

// 获取左侧栏信息和教育信息
export const eduEdit = async ({commit}, token) => {
  let params ={token};
  let res = await api.cvs.eduEdit(params);
}

export const setDownloadCv = ({commit}, cb) => {
  commit('SET_DOWNLOAD_CV', cb)
}

export const setEditorCvToken = ({commit}, token) => {
  commit('EDITOR_CV_TOKEN', token)
}

export const setCvPages = async function ({ commit }, payload) {
  try {
    commit(types.SET_CV_PAGES, payload)
  } catch (error) {
    console.log(error)
  }
}
export const setCvHeight = async function ({ commit }, payload) {
  try {
    commit(types.SET_CV_HEIGHT, payload)
  } catch (error) {
    console.log(error)
  }
}
export const setPageHeight = async function ({ commit }, payload) {
  try {
    commit(types.SET_PAGE_HEIGHT, payload)
  } catch (error) {
    console.log(error)
  }
}


// 设置教育模块
export const setCvEduKeyValue = async ({ state, commit }, data) => {
  let edus = JSON.parse(JSON.stringify(state.cv.edus));
  if (!edus[data.num]) {
    edus[data.num] = {};
  }
  edus[data.num][data.key] = data.value;
  commit('SET_CV_EDU_KEY_VALUE', edus);
}

// 获取默认模块标题
export const getCvSectionTitle = async ({ state, commit }, data) => {
  try {
    let res = await api.cvsV3.getCvSectionTitle()
    if (res.code === 1000) {
      commit('setCvSectionTitle', res.data)
    }
  } catch (err) {
    console.error(err)
  }
}
